export default "__VITE_ASSET__1f7ea5bc__"